import { QueryClient } from 'react-query'

/* The app's single React Query cache. Shared from here (like the Redux store) so switching
 * accounts can clear all cached server data, even from code that isn't a React component. */
export const queryClient = new QueryClient()
